import { parsePhoneNumber } from 'awesome-phonenumber';

export default function getNationalNumber(number?: string) {
  if (!number) {
    return '';
  }

  return parsePhoneNumber(number)?.number?.national || '';
}
